import { createSlice } from '@reduxjs/toolkit';

interface ImageState {
    selectedProjectIds: string[];
}

const initialState: ImageState = {
    selectedProjectIds: [],
};

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        selectProjectIds: (state, action) => {
            state.selectedProjectIds = [...action.payload]
        },
        clearSelectedProjectIds: (state) => {
            state.selectedProjectIds = [];
        },
    },
});

export const { 
    selectProjectIds,
    clearSelectedProjectIds,
} = projectSlice.actions;
export const selectSelectedProjectIds = (state: any) => state.project.selectedProjectIds;

export default projectSlice.reducer;
